/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Quick_Conversations_RecurringInputs */



/**
* | output |
* | --- |
* | "What came up most in my conversations this past month?" |
*
* @param {Chat_Quick_Conversations_RecurringInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_quick_conversations_recurring = /** @type {((inputs?: Chat_Quick_Conversations_RecurringInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Quick_Conversations_RecurringInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wat kwam de afgelopen maand het vaakst terug in mijn gesprekken?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Qu'est-ce qui est revenu le plus souvent dans mes conversations le mois dernier ?")
	return /** @type {LocalizedString} */ ("What came up most in my conversations this past month?")
});